import React from "react";
import { useTheme } from "@emotion/react";
import { IconButton, Box } from "@mui/material";
import { tokens } from "../theme";

/**
 * patients / team üst barındaki gradient IconButton’lar (İstatistik, davet vb.)
 * @param {'statistics'|'primary'} variant — statistics: Hasta istatistikleri ile aynı; primary: Ekle / davet CTA
 */
export default function GradientHeaderIconButton({
  onClick,
  icon,
  children,
  variant = "statistics",
  "aria-label": ariaLabel,
  sx: sxProp = {},
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const variantSx =
    variant === "primary"
      ? {
          background: `linear-gradient(135deg, ${colors.blueAccent[600]} 0%, ${colors.greenAccent[600]} 100%)`,
          color: "white",
          px: 3,
          py: 1.5,
          borderRadius: "12px",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: `0 8px 24px ${colors.blueAccent[500]}50`,
          },
        }
      : {
          background: `linear-gradient(135deg, ${colors.blueAccent[500]} 0%, ${colors.greenAccent[500]} 100%)`,
          color: "white",
          px: 3,
          py: 1.5,
          borderRadius: "12px",
          border: `2px solid ${colors.greenAccent[400]}40`,
          boxShadow: `0 4px 16px ${colors.blueAccent[500]}50`,
          transition: "all 0.3s ease",
          "&:hover": {
            background: `linear-gradient(135deg, ${colors.blueAccent[400]} 0%, ${colors.greenAccent[400]} 100%)`,
            transform: "translateY(-4px)",
            boxShadow: `0 6px 24px ${colors.greenAccent[500]}60`,
          },
        };

  return (
    <IconButton
      onClick={onClick}
      aria-label={ariaLabel}
      sx={{
        ...variantSx,
        ...sxProp,
      }}
    >
      {icon}
      <Box component="span" sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
        {children}
      </Box>
    </IconButton>
  );
}
